// Mirrors the BookingFunnelTagColor enum in prisma/schema.prisma.
// The swatch classes are kept visually in sync with the customer client so the
// CMS preview matches what customers see on the booking funnel card.
export const BOOKING_FUNNEL_TAG_COLORS = [
    { value: 'BURGUNDY', label: 'Burgundy', className: 'bg-[#561C2C] text-white' },
    { value: 'ROSE', label: 'Rosé', className: 'bg-[#F2D5DB] text-[#561C2C]' },
    { value: 'GREEN', label: 'Grün', className: 'bg-[#D8E8DC] text-[#2E5A3B]' },
    { value: 'BLUE', label: 'Blau', className: 'bg-[#D6E3F0] text-[#274B6D]' },
    { value: 'AMBER', label: 'Amber', className: 'bg-[#F8E3C0] text-[#7A4E12]' },
    { value: 'PURPLE', label: 'Violett', className: 'bg-[#E3D8EE] text-[#4C3268]' },
    { value: 'GRAY', label: 'Grau', className: 'bg-[#E5E3E0] text-[#333333]' },
    { value: 'NAVY', label: 'Navy', className: 'bg-[#30304A] text-white' },
    { value: 'ORANGE', label: 'Orange', className: 'bg-[#FF6439] text-white' },
    { value: 'PEACH', label: 'Pfirsich', className: 'bg-[#F0C5A6] text-[#7A3E1C]' },
    { value: 'SAND', label: 'Sand', className: 'bg-[#EFE0CD] text-[#6B5232]' },
] as const;

export type BookingFunnelTagColor = (typeof BOOKING_FUNNEL_TAG_COLORS)[number]['value'];

export const getTagColorClassName = (color: string) =>
    BOOKING_FUNNEL_TAG_COLORS.find((c) => c.value === color)?.className ?? BOOKING_FUNNEL_TAG_COLORS[0].className;
